// Module
var code = `<!-- The question about a file that already exists is the shared dialog element,
     so the browser owns the top layer, the dimmed page, the focus trap and the
     Escape key. The head keeps the amber ground. A replace removes the old
     asset, and the ground is the warning about that. -->
<dialog class="jumbotron-dialog" jumbotron-dialog="\$ctrl.showConflictModal"
    jumbotron-dialog-close="\$ctrl.cancelUpload()" aria-labelledby="asset-upload-conflict-heading">
    <div class="jumbotron-panel-head bg-warning text-dark">
        <h2 class="jumbotron-heading" id="asset-upload-conflict-heading">
            <i class="fas fa-exclamation-triangle" aria-hidden="true"></i> Replace Existing File<span
                ng-if="\$ctrl.conflicts.length > 1">s</span>?
        </h2>
        <button type="button" class="btn-close" ng-click="\$ctrl.cancelUpload()" aria-label="Close"></button>
    </div>
    <div class="jumbotron-dialog-body" ng-if="\$ctrl.conflicts.length > 0">
        <p class="mb-3">The following file<span ng-if="\$ctrl.conflicts.length > 1">s</span> will be replaced:
        </p>
        <div class="table-responsive mb-3">
            <table class="jumbotron-table asset-upload-conflict-table">
                <thead>
                    <tr>
                        <th class="jumbotron-table-head-cell">Name</th>
                        <th class="jumbotron-table-head-cell">Orientation</th>
                        <th class="jumbotron-table-head-cell">File</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="conflict in \$ctrl.conflicts">
                        <td class="jumbotron-table-cell text-truncate asset-upload-conflict-name"
                            title="{{conflict.parsed.name}}">
                            <strong>{{conflict.parsed.name}}</strong></td>
                        <td class="jumbotron-table-cell"><span class="badge bg-secondary">{{\$ctrl.getOrientationText({orientation:
                                conflict.existingAsset.orientation})}}</span></td>
                        <td class="jumbotron-table-cell text-truncate asset-upload-conflict-file"
                            title="{{conflict.file.name}}"><small>{{conflict.file.name}}</small></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <p class="jumbotron-note mb-0">
            <i class="fas fa-info-circle" aria-hidden="true"></i> The old asset<span
                ng-if="\$ctrl.conflicts.length > 1">s</span>
            will be removed from the library and replaced with the new file<span
                ng-if="\$ctrl.conflicts.length > 1">s</span>.
        </p>
    </div>
    <div class="jumbotron-dialog-foot">
        <button type="button" class="btn btn-sm btn-outline-secondary" ng-click="\$ctrl.cancelUpload()">
            <i class="fas fa-times" aria-hidden="true"></i> Cancel All </button>
        <button type="button" class="btn btn-sm btn-primary" ng-click="\$ctrl.confirmReplace()">
            <i class="fas fa-check" aria-hidden="true"></i> Replace All </button>
    </div>
</dialog>
`;
// Exports
export default code;